import React from "react";
import { NavLink } from "react-router-dom";

const Work = () => {
  return (
    <div className="index-container">
      <div className="img-box">
       
        <div className="img1">
        <img src="./images/1662045054-frame-186.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662045058-frame-4.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        
        <div className="img1">
        <img src="./images/1662046774-frame-201 (1).webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662119753-newsletter-20_index.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662127035-newsletter-17_index.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662119862-newsletter-15_index.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662119803-newsletter-19_index.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662119887-newsletter-14_index (1).webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662119910-newsletter-13_index (1).webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662119936-newsletter-12_index (1).webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662119965-newsletter-11_index.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662120004-newsletter-7_index.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662120055-newsletter-5_index.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662120181-1-210314-2.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662120284-newsletter-16_index.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662127035-newsletter-17_index.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662120079-newsletter-3_index.webp" alt="" />
        <div className="tranparent"></div>
        </div>
       
        <div className="img1">
        <img src="./images/1662120214-newsletter-2_index.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662385383-frame-2.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662385415-frame-10.webp" alt="" />
        <div className="tranparent"></div>
        </div>
        <div className="img1">
        <img src="./images/1662385473-frame-3.webp" alt="" />
        <div className="tranparent"></div>
        </div>
      </div>
      <div className="back-button">
        <NavLink className="backlink" to="/"> <span className="back">&#8592;</span> <span className="back-button-content">BACK</span> </NavLink>
        
      </div>
    </div>
  );
};

export default Work;
